import { PopupDtoPredefinedTypeEnum } from '@coretava/api/core-service';
import { Tabs } from '@gamiphy/loyalty-station-desktop/store/ui';

export const POPUP_TYPE_OPEN_SAME_PAGE = [PopupDtoPredefinedTypeEnum.Referral, PopupDtoPredefinedTypeEnum.WelcomePoints];

export const POPUP_AUTO_CLOSES_AFTER = 30000;

export const PopupsTypesMap: Partial<Record<PopupDtoPredefinedTypeEnum, Tabs>> = {
  referral: Tabs.Referral,
  welcomePoints: Tabs.WelcomeGift,
};
